<template>
  <page :title="$t('review.title')" size="is-xlarge">
    <div slot="page-header-right">
      <modal-opener
        :component="require('./Form.vue').default"
        :props="{ whenSaved: () => accounts.load()}"
      >
        <button slot="trigger" class="button is-primary">
          <b-icon icon="plus"></b-icon>
          <span>{{$t('account.add')}}</span>
        </button>
      </modal-opener>
    </div>

    <div class="box">
      <filters @input="filters => accounts.filter(filters).load()"></filters>

      <hr />
      <div class="card-content is-paddingless">
        <b-table
          :data="accounts.data"
          :loading="accounts.loading"
          paginated
          backend-pagination
          pagination-position="bottom"
          :current-page="accounts.current_page"
          :per-page="accounts.per_page"
          :total="accounts.total"
          @page-change="page => accounts.changePage(page)"
          backend-sorting
          @sort="(field, direction) => accounts.sort(field, direction)"
          :default-sort="['id', 'desc']"
          class="is-middle"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="Id" sortable width="100">{{ props.row.id }}</b-table-column>

            <b-table-column field="publisher_id" label="Publisher">
              <router-link
                class="has-text-grey"
                :to="'/publishers/' + props.row.publisher.id"
              >{{ props.row.publisher.name }}</router-link>
            </b-table-column>

            <b-table-column field="Email" label="Email" sortable>{{ props.row.email }}</b-table-column>

            <b-table-column label="Magazines">
              <div v-if="props.row.magazines.length > 0">
                <span class="tag mr-1">{{ props.row.magazines[0].name }}</span>

                <b-dropdown v-if="props.row.magazines.length > 1">
                  <span
                    slot="trigger"
                    class="button is-small"
                    @click="props.row.showAllMagazines = true"
                  >+{{ props.row.magazines.length - 1}}</span>

                  <div class="dropdown-item">
                    <ul>
                      <li
                        v-for="magazine in props.row.magazines"
                        :key="magazine.id"
                      >{{ magazine.name }}</li>
                    </ul>
                  </div>
                </b-dropdown>
              </div>
            </b-table-column>

            <b-table-column field="created_at" label="Created" width="300">
              <b-tooltip :label="props.row.created_at">
                <span class="has-text-grey">{{ props.row.created_at | date }}</span>
              </b-tooltip>
            </b-table-column>

            <b-table-column custom-key="actions" width="200">
              <div class="is-pulled-right">
                <modal-opener
                  :component="require('./Form.vue').default"
                  :props="{
                    account: props.row,
                    whenSaved: () => accounts.load()
                  }"
                >
                  <button slot="trigger" class="button mr-2">
                    <span>Edit</span>
                  </button>
                </modal-opener>

                <confirm-dialog
                  @confirmed="removeAccount(props.row)"
                  type="is-danger"
                  :message="`Are you sure. You are deleting review account ${props.row.id}.`"
                  confirm-text="Delete Account"
                >
                  <button slot="trigger" class="button">Delete</button>
                </confirm-dialog>
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>{{$tc('Nothinghere')}}</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>

<script>
import Filters from "./Filters";

export default {
  components: {
    Filters
  },

  data() {
    return {
      accounts: new window.PaginatedRemoteCollection(
        "/admin/api/review/accounts"
      )
    };
  },

  created() {
    this.accounts.load();
  },

  methods: {
    removeAccount(account) {
      new window.Form()
        .delete(`/admin/api/review/accounts/${account.id}`)
        .then(() => {
          this.$buefy.toast.open(`Account ${account.id} has been deleted.`);

          this.accounts.load();
        });
    }
  }
};
</script>
